/**
 * Gli indirizzi dentro la commessa e l'outlet della panoramica.
 *
 * Le schede della commessa stanno in `workspace/WorkspaceTabs` (GI-237) e le
 * monta la shell Carta: sparirebbero a ogni cambio di schermata se vivessero
 * qui. Restano qui gli indirizzi che piu' schermate compongono.
 */
import '../carta/screen.css'
import { Outlet, useParams } from 'react-router-dom'

/** Il monitor ingest resta su `/ingest/:jobId`; la commessa viaggia nella query
 *  cosi' la shell Carta non smonta sezioni e contesto. */
export function ingestPath(jobId: string, inspectionId: string): string {
  return `/ingest/${jobId}?inspection=${encodeURIComponent(inspectionId)}`
}

export function receiptPath(uploadId: string, inspectionId: string): string {
  return `/uploads/${uploadId}/receipt?inspection=${encodeURIComponent(inspectionId)}`
}

export function inspectionFromSearch(search: string): string {
  const value = new URLSearchParams(search).get('inspection')
  if (value === null || value === '') return ''
  return /^[A-Za-z0-9._~-]+$/.test(value) ? value : ''
}

export function InspectionLayout(): JSX.Element {
  const inspectionId = useParams().inspectionId ?? ''
  return (
    <section data-inspection={inspectionId} className="workspace-body">
      <Outlet />
    </section>
  )
}
